import APIClient from '../../../lib/api';

class NotificationService {
  async getAll(params = {}) {
    const defaultParams = {
      skip: 0,
      limit: 50,
    };
    
    const queryParams = { ...defaultParams, ...params };
    
    try {
      const response = await APIClient.notifications.getAll(queryParams);
      
      // API returns { data: [...], total: X, unread_count: Y }
      const apiResponse = response.data;
      
      const notificationsArray = Array.isArray(apiResponse?.data) 
        ? apiResponse.data 
        : (Array.isArray(apiResponse) ? apiResponse : []);
      
      return {
        success: true,
        data: notificationsArray,
        total: apiResponse?.total ?? notificationsArray.length,
        unread_count: apiResponse?.unread_count ?? 0
      };
    } catch (error) {
      console.error('NotificationService.getAll Error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα φόρτωσης ειδοποιήσεων'
      };
    }
  }

  async getById(notificationId) {
    try {
      const response = await APIClient.notifications.getById(notificationId);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('NotificationService.getById Error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα φόρτωσης ειδοποίησης'
      };
    }
  }

  async getUnreadCount() {
    try {
      const response = await APIClient.notifications.getUnreadCount();
      return {
        success: true,
        count: response.data.unread_count || 0
      };
    } catch (error) {
      console.error('NotificationService.getUnreadCount Error:', error);
      return {
        success: false,
        count: 0,
        error: error.response?.data?.detail || error.message || 'Σφάλμα φόρτωσης αριθμού ειδοποιήσεων'
      };
    }
  }

  async markAsRead(notificationId) {
    try {
      const response = await APIClient.notifications.markAsRead(notificationId);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('NotificationService.markAsRead Error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα ενημέρωσης ειδοποίησης'
      };
    }
  }

  async markAllAsRead() {
    try {
      const response = await APIClient.notifications.markAllAsRead();
      return {
        success: true,
        updated_count: response.data.updated_count || 0
      };
    } catch (error) {
      console.error('NotificationService.markAllAsRead Error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα ενημέρωσης ειδοποιήσεων'
      };
    }
  }

  async delete(notificationId) {
    try {
      await APIClient.notifications.delete(notificationId);
      return {
        success: true
      };
    } catch (error) {
      console.error('NotificationService.delete Error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα διαγραφής ειδοποίησης'
      };
    }
  }
}

export default new NotificationService();

